<app-mosaic-como-long-push-atom
  *ngIf="!isLoading && !comoUser && (isComoEnabled$ | async)"
  [heading]="heading ? heading : 'como.already-member'"
  [text]="text ? text : 'como.connect-account'"
  [textColor]="textColor"
  [backgroundColor]="backgroundColor"
  (click)="onClick()"
>
</app-mosaic-como-long-push-atom>
